// The visible FAQ and LandingExperimentSeo use this same data.
export const landingFaqs = [
  {
    questionKey: 'landingV2_faq1Question',
    answerKey: 'landingV2_faq1Answer',
    question: 'How do I create AI images with Promptchan?',
    answer:
      'In Create, write a prompt, choose a style, then generate. Adjust settings and download your favorites.',
  },
  {
    questionKey: 'landingV2_faq2Question',
    answerKey: 'landingV2_faq2Answer',
    question: 'Can I create AI videos from images or text?',
    answer:
      'Write a prompt in the Video tab or Animate an image. Choose the motion, add dialogue or sound, and use Extend to continue a clip.',
  },
  {
    questionKey: 'landingV2_faq3Question',
    answerKey: 'landingV2_faq3Answer',
    question: 'How do I change an image with Tweak?',
    answer:
      'Open Tweak and describe a new outfit, background, pose or lighting. Keep each instruction focused.',
  },
  {
    questionKey: 'landingV2_faq4Question',
    answerKey: 'landingV2_faq4Answer',
    question: 'What does Clone do?',
    answer:
      'Clone loads a community creation’s prompt and settings into Create for your own variation. You can also Animate images from Explore.',
  },
  {
    questionKey: 'landingV2_faq5Question',
    answerKey: 'landingV2_faq5Answer',
    question: 'Can I create and chat with an AI girlfriend?',
    answer:
      'Create a character or find one in Discover. Chat, roleplay, and request scene photos or videos from your companion.',
  },
  {
    questionKey: 'landingV2_faq6Question',
    answerKey: 'landingV2_faq6Answer',
    question: 'Can I make AI voice calls?',
    answer:
      'Yes. Choose a voice for your character, then start a voice call from the chat header. You can also exchange voice messages in the conversation.',
  },
  {
    questionKey: 'landingV2_faq7Question',
    answerKey: 'landingV2_faq7Answer',
    question: 'Can I find an AI boyfriend or anime companion too?',
    answer:
      'Yes. Discover has male and female companions in realistic and anime styles. You can also create your own.',
  },
  {
    questionKey: 'landingV2_faq8Question',
    answerKey: 'landingV2_faq8Answer',
    question: 'Is Promptchan free?',
    answer:
      'New accounts get free Gems and starter chat messages. Paid plans add Gems, styles and quality options. AI video requires Pro and uses Gems.',
  },
  {
    questionKey: 'landingV2_faq9Question',
    answerKey: 'landingV2_faq9Answer',
    question: 'Can I keep my creations private?',
    answer:
      'Check your plan and settings for private generation options. Choose what to publish, and download favorites to keep.',
  },
]
